import type { PropsWithChildren } from 'react';
import { ErrorBoundary } from '../../components/common/ErrorBoundary';
import { ToastProvider } from '../../components/ui/ToastProvider';
import { AppProvider } from '../../lib/app/AppContext';

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <AppProvider>
        <ToastProvider>{children}</ToastProvider>
      </AppProvider>
    </ErrorBoundary>
  );
}
